import type { StoreActionApi } from 'react-sweet-state';

import { fireOperationalAnalyticsWithContext } from '@atlassian/jira-ui-modifications-analytics';
import { getAnalytics } from '@atlassian/jira-ui-modifications-fields-configuration';
import type {
	BufferForChangeId,
	ChangeId,
	IssueAdjustmentsState,
	StoreContainerProps,
} from '../../../types';
import { findAppsWhichDidNotSendChangesBeforeTimeout } from '../utils';

export const sendBufferFinalMetrics =
	(changeId: ChangeId, bufferForChangeId: BufferForChangeId) =>
	(
		{ getState }: StoreActionApi<IssueAdjustmentsState>,
		{ viewType, createAnalyticsEvent }: StoreContainerProps,
	) => {
		const {
			bufferErrors,
			analyticsData: { issueAdjustmentModulesCount, configuredAppsCount, adjustmentsAPILatency },
		} = getState();
		const appIds = Object.keys(bufferForChangeId).join();

		if (bufferErrors === null) {
			fireOperationalAnalyticsWithContext(
				createAnalyticsEvent({}),
				'bufferApplication success',
				viewType,
				{
					changeId,
					appIds,
				},
			);
		}

		getAnalytics(viewType).stopTTI({
			issueAdjustmentModulesCount,
			adjustmentsAPILatency,
			configuredAppsCount,
			completionStatus:
				findAppsWhichDidNotSendChangesBeforeTimeout(bufferForChangeId).length > 0
					? 'buffering_timeout'
					: 'success',
			viewType,
			appIds,
		});
	};

export const sendBufferConflictMetrics =
	(changeId: ChangeId, bufferForChangeId: BufferForChangeId) =>
	async (
		{ getState }: StoreActionApi<IssueAdjustmentsState>,
		{ viewType, createAnalyticsEvent }: StoreContainerProps,
	) => {
		const {
			analyticsData: { issueAdjustmentModulesCount, configuredAppsCount, adjustmentsAPILatency },
		} = getState();
		const appIds = Object.keys(bufferForChangeId).join();

		fireOperationalAnalyticsWithContext(
			createAnalyticsEvent({}),
			'multipleApps conflict',
			viewType,
			{
				changeId,
				appIds,
			},
		);

		getAnalytics(viewType).stopTTI({
			issueAdjustmentModulesCount,
			adjustmentsAPILatency,
			configuredAppsCount,
			completionStatus: 'buffering_conflict',
			viewType,
			appIds,
		});
	};
